import { RandomInteger } from "./RandomInteger"

/**
 * Randomly selects items from array with deterministic seed.
 *
 * Uses RandomInteger to select indices, allowing same seed to produce same choices.
 *
 * @param n - Number of items to select
 * @param choices - Array of items to choose from
 * @param seed - Random seed for reproducibility
 * @returns Iterator yielding randomly selected items
 *
 * @example
 * ```ts
 * import { RandomChoice } from "@pdfking/tfunc"
 *
 * const suits = ['♠', '♥', '♦', '♣']
 * const cards = [...RandomChoice(5, suits, 42)]
 * // ['♦', '♠', '♣', '♥', '♦']
 * ```
 */
export const RandomChoice = function* <T>(
  n: number,
  choices: T[],
  seed: number
): IterableIterator<T> {
  // Generate random indices in the range [0, choices.length - 1]
  const indices = RandomInteger(n, 0, choices.length - 1, seed)

  // Map each random index to the corresponding choice
  for (const index of indices) {
    yield choices[index]
  }
}
